const ARROW_LEFT = '\u2190';
const ARROW_RIGHT = '\u2192';

export { ARROW_LEFT, ARROW_RIGHT };
